module.exports = __webpack_public_path__ + "img/artemis_thumbnail.88694523.jpg";